import _slicedToArray from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useMemo } from 'react';
import { useBestBuyInputAmount, useBestBuyPair } from "../../../state/dex/hooks";
import { useBestBuyAllowance } from "./useBestBuyAllowance";
import { MaxUint256 } from '@ethersproject/constants';
import BigNumber from 'bignumber.js';
import { FixedPointNumber } from "../../../utils/fixedPoint";
import { toBigNumberWithDecimal } from "../../../utils/numbers";
import { useActiveOrdersOccupiedAmount } from "./useActiveOrdersOccupiedAmount";
export var useNeedApprove = () => {
  var _useBestBuyPair = useBestBuyPair(),
      _useBestBuyPair2 = _slicedToArray(_useBestBuyPair, 1),
      inputToken = _useBestBuyPair2[0];

  var _useBestBuyInputAmoun = useBestBuyInputAmount(),
      inputAmount = _useBestBuyInputAmoun.inputAmount;

  var allowance = useBestBuyAllowance(inputToken);
  var activeOrdersOccupiedAmount = useActiveOrdersOccupiedAmount(inputToken);
  var decimals = inputToken === null || inputToken === void 0 ? void 0 : inputToken.decimals; // @todo: verify activeOrderBalance

  var needApprove = useMemo(() => {
    if (!allowance) return false;
    if (allowance.eq(MaxUint256.toString())) return false;
    var amount = isNaN(Number(inputAmount)) ? '0' : String(inputAmount || 0); // @notice: amount 是计算值，可能会出现小数位数大于 token 的 decimal 的情况，需要先保护一下

    amount = new BigNumber(amount).decimalPlaces(decimals).toString();
    var formattedAllowance = toBigNumberWithDecimal(allowance, decimals);
    var formattedActiveOrdersOccupiedAmount = toBigNumberWithDecimal(activeOrdersOccupiedAmount, decimals);
    if (new FixedPointNumber(amount, decimals).gt(formattedAllowance.minus(formattedActiveOrdersOccupiedAmount))) return true;
    return false;
  }, [inputAmount, allowance, inputToken]);
  return needApprove;
};